import React from 'react'
import { Route, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import useSubscribeRefresh from 'use-subscribe-actions'
import { useHasSitesOnProduction } from 'store'
import EmptyScreen from 'packages/ui/EmptyScreen'
import RouteGuard from 'components/AuthenticatedLayout/RouteGuard/RouteGuard'

import WAN from './WAN'
import Card from './Card/Card'


const Layout = () => {
  const hasSitesOnProduction = useHasSitesOnProduction()
  const {t} = useTranslation()
  const navigate = useNavigate()
  useSubscribeRefresh(() => navigate('/monitoring/wan'))

  return hasSitesOnProduction
    ? <WAN />
    : <EmptyScreen icon={'gauge-high'}>{t('ui_elements.service_soon')}</EmptyScreen>
}

export const WANRoutes = () => [
  <Route path="monitoring/wan" element={
    <RouteGuard requiredRoles={['wan']}>
      <Layout />
    </RouteGuard>
  } key={'wan'}>
    <Route path=":id" element={<Card />} />
  </Route>
]

export default WANRoutes
